import { render, staticRenderFns } from "./expoJoinGuide.vue?vue&type=template&id=947db61e&scoped=true"
import script from "./expoJoinGuide.vue?vue&type=script&lang=js"
export * from "./expoJoinGuide.vue?vue&type=script&lang=js"
import style0 from "./expoJoinGuide.vue?vue&type=style&index=0&id=947db61e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947db61e",
  null
  
)

export default component.exports